import router from '../services/router_service';
import companyIndexController from '../controllers/company_index_controller';

router.on('route:companies', companyIndexController);
